import Api from '../api'
export default ({
  state: {
    itemMasterLists: [],
    itemMasterListsParent: [],
    itemMasterListByItemType: [],
    itemMasterListByItemTypeAndAvaliable: [],
    itemCodeNo: null,
    commissionLists: []
  },
  mutations: {
    MAX_ITEM_CODE_NO(state, maxItemCodeNo) {
      state.itemCodeNo = maxItemCodeNo
    },
    ADD_ITEM_MASTER (state, itemMasterLists) {
      let itemMasterList = state.itemMasterLists.concat(itemMasterLists)
      state.itemMasterLists = itemMasterList
    },
    SET_ITEM_MASTER_LIST_SITE (state, itemMasterListSite) {
      state.itemMasterListsSite = itemMasterListSite
    },
    SET_ITEM_MASTER_LIST (state, itemMasterList) {
      state.itemMasterLists = itemMasterList
    },
    SET_ITEM_MASTER_LIST_PARENT (state, itemMasterList) {
      state.itemMasterListsParent = itemMasterList
    },
    DELETE_ITEM_MASTER (state, itemMasterId) {
      let itemMaster = state.itemMasterLists.filter(a => a.id !== itemMasterId.id)
      state.itemMasterLists = itemMaster
    },
    SETITEMMASTERLISTBYITEMTYPE (state, itemMasterListByItem) {
      state.itemMasterListByItemType = itemMasterListByItem
    },
    SET_ITEM_MASTER_LIST_BY_ITEM_TYPE_Available (state, itemMasterByItemTypeAndAvaliable) {
      state.itemMasterListByItemTypeAndAvaliable = itemMasterByItemTypeAndAvaliable
    },
    UPDATE_ITEM_MASTER(state, updatedItemMaster) {
      state.itemMasterLists = state.itemMasterLists.map(itemMaster => itemMaster.id !== updatedItemMaster.id ? itemMaster : {...itemMaster, ...updatedItemMaster})
    },
    // Commision
    ADD_COMMISSION(state, commission) {
      let commissionList = state.commissionLists.concat(commission)
      state.commissionLists = commissionList
    },
    COMMISSION_LIST(state, commissionList) {
      state.commissionLists = commissionList
    },
    UPDATE_COMMISSION(state, updateCommission) {
      state.commissionLists = state.commissionLists.map(commission => commission.id !== updateCommission.id ? commission : {...commission, ...updateCommission})
    },
    DELETE_COMMISSION(state, deleteCommision) {
      let commission = state.commissionLists.filter(a => a.id !== deleteCommision.id)
      state.commissionLists = commission
    }
  },
  actions: {
    async createItemMaster({commit}, item) {
      let response = await Api.request('post', '/item/' +
      this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, item, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let savedItemMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ITEM_MASTER', savedItemMaster)
      }
      return response
    },
    async loadItemMasterList({commit}) {
      let response = await Api.request('get', '/item/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.warehouseData.id + '', null)
      commit('SET_ITEM_MASTER_LIST', response.data.data)
      return response
    },
    async loadItemMasterListChild({commit}, org) {
      let response = await Api.request('get', '/item/' + org + '', null)
      commit('SET_ITEM_MASTER_LIST_PARENT', response.data.data)
      return response
    },
    async deleteItemMaster({commit}, itemMaster) {
      let response = await Api.request('delete', '/item/' + itemMaster.itemId + '/' + this.getters.userId + '/' + itemMaster.deleteReason)
      let itemMasterLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_ITEM_MASTER', itemMasterLists)
      }
      return response
    },
    async loadItemMasterListByItemType({commit}) {
      let response = await Api.request('get', '/item/itemMasterListByItemType/' + this.state.organisationid + '/' + this.state.fyId + '/' + '0' + '/' + this.state.warehouseData.id + '/' + this.getters.userId + '/' + 'purchase', null)
      commit('SETITEMMASTERLISTBYITEMTYPE', response.data.data)
    },
    async loadItemMasterListByItemTypePurchase({commit}) {
      let response = await Api.request('get', '/item/itemMasterListByItemType/' + this.state.organisationid + '/' + this.state.fyId + '/' + '0' + '/' + this.state.warehouseData.id + '/' + this.getters.userId + '/' + 'purchase', null)
      commit('SETITEMMASTERLISTBYITEMTYPE', response.data.data)
    },
    async loadItemMasterListByItemTypeSales({commit}) {
      let response = await Api.request('get', '/item/itemMasterListByItemType/' + this.state.organisationid + '/' + this.state.fyId + '/' + '0' + '/' + this.state.warehouseData.id + '/' + this.getters.userId + '/' + 'sales', null)
      commit('SETITEMMASTERLISTBYITEMTYPE', response.data.data)
    },
    async loadItemMasterListByItemTypeAndAvailable({commit}) {
      let response = await Api.request('get', '/item/itemMasterListByItemTypeAndAvailable/' + this.state.organisationid + '/' + this.state.fyId + '/' + '0' + '/' + this.state.warehouseData.id + '/' + this.getters.userId, null)
      commit('SET_ITEM_MASTER_LIST_BY_ITEM_TYPE_Available', response.data.data)
      return response
    },
    async updateItemMaster({commit}, itemMaster) {
      // let data = ''
      // for (let item of itemMaster.values()) {
      //   data = JSON.parse(item)
      // }
      let resp = await Api.request('put', '/item/' + this.state.fyId + '/' + this.getters.organisationId + '/' + this.getters.userId, itemMaster, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if (resp.data.status === 'SUCCESS') {
        commit('UPDATE_ITEM_MASTER', resp.data.data)
      }
      return resp
    },
    async maxItemCodeNo ({commit}) {
      let response = await Api.request('get', '/item/itemMaxCode/' + this.state.organisationid)
      let responseValue = response.data.data
      commit('MAX_ITEM_CODE_NO', responseValue)
      return response
    },
    // Commsion
    async listOfCommission({commit}) {
      let response = await Api.request('get', '/item/itemWiseCommissionList/' + this.state.organisationid)
      if (response.data.status === 'SUCCESS') {
        commit('COMMISSION_LIST', response.data.data)
      }
    },
    async addCommission({commit}, commission) {
      let response = await Api.request('post', '/item/saveItemWiseCommission/' + this.state.organisationid + '/' + this.getters.userId, commission)
      if (response.data.status === 'SUCCESS') {
        commit('ADD_COMMISSION', response.data.data)
      }
      return response
    },
    async updateCommission({commit}, commission) {
      let response = await Api.request('put', '/item/updateItemCommissionMaster/' + this.state.organisationid + '/' + this.getters.userId, commission)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_COMMISSION', response.data.data)
      }
      return response
    },
    async deleteCommision({commit}, commission) {
      let response = await Api.request('delete', '/item/deleteItemCommissionMaster/' + commission.id + '/' + this.getters.userId + '/' + commission.deleteReason)
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_COMMISSION', response.data.data)
      }
      return response
    },
    async updatePurchaseSalesRate({commit}, data) {
      let response = await Api.request('put', '/item/updatePurchaseAndSalesRate/' + data.itemId + '/' + data.purchaseRate + '/' + data.salesRate)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_SALES_PURCHASE_RATE', response.data.data)
        return response
      }
    },
    async posStockIn({commit}, stock) {
      let response = await Api.request('put', '/item/posStockIn/' + this.state.organisationid + '/' + this.getters.userId + '/' + this.state.fyId, stock)
      if (response.data.status === 'SUCCESS') {
        // commit('UPDATE_STOCK_DETAILS_FOR_POS', response.data.data)
      }
      return response
    },
    async uploadExcelItemMaster({commit}, item) {
      let response = await Api.request('post', '/fileUpload/excelFileUploadForItemMaster/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, item, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let savedItemMaster = response
      return savedItemMaster
    },
    async uploadExcelAccoungMaster({commit}, item) {
      let response = await Api.request('post', '/fileUpload/excelFileUploadForAllAccount/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '/' + 'Customer', item, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let savedItemMaster = response
      return savedItemMaster
    },
    async uploadclosingExcel({commit}, item) {
      let response = await Api.request('post', '/fileUpload/excelFileUploadCustomerOpening/' + this.state.organisationid + '/' + this.state.user.id, item, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let savedItemMaster = response
      return savedItemMaster
    },
    async uploadFollowUpExcel({commit}, item) {
      let response = await Api.request('post', '/crmFollowUp/uploadExcelCrmFollowUp/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, item, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let savedItemMaster = response
      return savedItemMaster
    },
    async uploadDeleteExcel({commit}, item) {
      let response = await Api.request('post', '/fileUpload/deleteExcelFileUploadForItemMaster/' + this.state.organisationid + '/' + this.state.user.id, item, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let savedItemMaster = response
      return savedItemMaster
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/itemMaster.js